import {
  AppDispatch,
  getClientOrganization,
  getClientOrganizationRequest,
  Organization } from
"@src/redux";
import { Button, Col, Row, Typography } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AiFillCaretDown } from "react-icons/ai";
import { BsArrowDown } from "react-icons/bs";
import { FaLongArrowAltDown, FaMedkit, FaUser, FaUsers } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
interface AttributesCardProps {
  onCancel: Function;
  client: Organization;
}
const AttributesCard: React.FC<AttributesCardProps> = (props) => {
  const { t } = useTranslation();
  const { onCancel, client } = props;
  const dispatch = useDispatch<AppDispatch>();
  // const { result: organization } = useSelector(getClientOrganization);
  // useEffect(() => {
  //   dispatch(getClientOrganizationRequest({ filter: { id: client?.id } }));
  // }, [client]);
  return (
    <div>
      {client?.rootLevelList &&
      client?.rootLevelList?.length > 0 &&
      client?.rootLevelList?.map((list, levelIndex) => {
        return (
          <>
              <div className="attributes-container">
                <div className="modal-header">
                  <Typography.Title level={4}>{list?.name}</Typography.Title>
                </div>
                <Row className="icon-row" justify="space-around" align="middle">
                  <Col className="icon-col">
                    <FaMedkit
                    className={
                    list.allowKitAssign ?
                    "attribute-icon" :
                    "attribute-icon-un-fill"} />

                  
                  </Col>
                  <Col className="icon-col">
                    <FaUsers className="attribute-icon" />
                    <span>{client?.subjectLabel}</span>
                  </Col>
                  <Col className="icon-col">
                    <FaUser
                    className={
                    list.allowOperatorLogin ?
                    "attribute-icon" :
                    "attribute-icon-un-fill"} />

                  
                  </Col>
                </Row>
                <div className="attributes-list">
                  <div className="attributes-header">
                    <b> Attributes</b>
                  </div>
                  {list.levelAttributeList &&
                list?.levelAttributeList?.length > 0 ?
                <div style={{ minHeight: "80px" }}>
                      {list?.levelAttributeList.map(
                    (attributes, index: any) => {
                      return (
                        <Row
                          justify={"space-between"}
                          style={{ margin: "10px" }}>
                          
                              <Col span={2}>{`${Number(
                              index + 1
                            ).toString()}.`}</Col>
                              <Col span={7}>{attributes?.name}</Col>
                              <Col span={15}>
                                {attributes?.optionList &&
                            attributes?.optionList?.length > 0 &&
                            attributes?.optionList?.map(
                              (option, optIndex) =>
                              `${option}${
                              optIndex !==
                              Number(
                                attributes?.optionList?.length
                              ) -
                              1 && ", "}  `

                            )}
                              </Col>
                            </Row>);

                    }
                  )}
                    </div> :

                <Typography.Text className="no-attributes">
                      No attributes created
                    </Typography.Text>}
                
                </div>
              </div>
              {levelIndex !==
            Number(client?.rootLevelList?.length || 0) - 1 &&
            <div className="attributes-item-container">
                  <FaLongArrowAltDown size={35} color="rgb(207, 207, 207)" />
                </div>}
            
            </>);

      })}

      <Row justify={"end"} style={{ marginTop: "20px" }}>
        <Button danger onClick={() => onCancel()}>
          {t("close")}
        </Button>
      </Row>
    </div>);

};

export default AttributesCard;